import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../enums';
import { IConfig } from '../interfaces/config';
import { IConfigFormat } from '../interfaces/config.format';
import { isNullOrUndefined } from '../shared/common-utils';

import loginConfig from '../config/login.config.json';
import sidebarConfig from '../config/side-bar.config.json';
import logoConfig from '../config/logo.config.json';
import addUserConfig from '../config/add-user.config.json';
import deleteUserConfig from '../config/delete-user.config.json';
import viewUserConfig from '../config/view-user.config.json';
import editUserConfig from '../config/edit-user.config.json';
import changePasswordConfig from '../config/change-password.config.json';
import otpChangePswdConfig from '../config/otpChangePswd.config.json';
import otpForgotPswdConfig from '../config/otpForgotPswd.config.json';
import forgotPasswordConfig from '../config/forgot-password.config.json';
import listUsersConfig from '../config/list-users.config.json';
import listApplicationConfig from '../config/list-application.config.json';
import listResourcesConfig from '../config/list-resources.config.json';
import listRolesConfig from '../config/list-roles.config.json';
import errorMessageConfig from '../config/error-message.config.json';


@Injectable({
  providedIn: 'root'
})
export class InitService {
  private config: IConfig = {};
  count  = 0


  CONFIG_MAP: Record<string, any> = {
  'config/login.config.json': loginConfig,
  'config/side-bar.config.json': sidebarConfig,
  'config/logo.config.json': logoConfig,
  'config/add-user.config.json': addUserConfig,
  'config/delete-user.config.json': deleteUserConfig,
  'config/view-user.config.json': viewUserConfig,
  'config/edit-user.config.json': editUserConfig,
  'config/change-password.config.json': changePasswordConfig,
  'config/otpChangePswd.config.json': otpChangePswdConfig,
  'config/otpForgotPswd.config.json': otpForgotPswdConfig,
  'config/forgot-password.config.json': forgotPasswordConfig,
  'config/list-users.config.json': listUsersConfig,
  'config/list-application.config.json': listApplicationConfig,
  'config/list-resources.config.json': listResourcesConfig,
  'config/list-roles.config.json': listRolesConfig,
  'config/error-message.config.json': errorMessageConfig
};

  constructor(
    private http: HttpClient,
  ) { }

  getConfig(type: Config) {
  return this.deepClone(this.config[type as keyof IConfig]);
}

 loadConfig(args: IConfigFormat) {
    return new Promise((resolve, reject) => {
      if (!isNullOrUndefined(args.path) && !isNullOrUndefined(args.configType)) {
        try {
          const res = this.CONFIG_MAP[args.path];
          if (res) {
            this.config[args.configType as keyof IConfig] = res;
            resolve(res);
          } else {
            reject(new Error(`Configuration not found for path: ${args.path}`));
          }
        } catch (err) {
          reject(new Error(`Could not load Configuration: ${err}`));
        }
      } else {
        throw new Error('Could not load Configuration');
      }
    });
  }


  isEmptyField(value: any) {
    if (isNullOrUndefined(value) || value === '') {
      return true;
    }
    return false;
  }

  deepClone(object: any): any {
    if (this.isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj = new object.constructor();
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];
      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }  
}
